import { render, staticRenderFns } from "./therapyListing.vue?vue&type=template&id=0c00950e&"
import script from "./therapyListing.vue?vue&type=script&lang=js&"
export * from "./therapyListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports